import { useParams } from "react-router-dom";
import {
  useGetBillsDetails,
  useGetBillsItems,
} from "../../../../../../hooks/api/queries";

export const useEditBills = ({ isEnabled = false }) => {
  const { id } = useParams();
  const {
    data: billsDetails,
    isLoading,
    refetch: refetchBillDetails,
  } = useGetBillsDetails({ id });

  const { data: billsItems, isLoading: isLoadingBillsItems } = useGetBillsItems(
    { id, isEditMode: true, isEnabled },
  );

  return {
    isLoading: isLoadingBillsItems || isLoading,
    billsItems: billsItems || [],
    billsDetails,
    refetchBillDetails,
  };
};
